import { AsyncThunk } from "@reduxjs/toolkit";
import { AppDispatch } from "../../../app/store";
import { FetchReportParams } from "../../../features/Reports/thunks/report.thunk";
import {
  SelectedZoneOrWorkplace,
  SelectedZoneOrWorkplaceType
} from "../../../features/Reports/slices/report.slice";
import { Weekdays } from "../../Pickers/WeekdayPicker/weekday-picker.component";

type RefetchCapaReportWithSelected = {
  defaultParams: any;
  currentFloors: { id: number; open: boolean }[];
  fetchReport: AsyncThunk<void, FetchReportParams, any>;
  selectedZoneOrWorkplace: SelectedZoneOrWorkplace;
  selectedWeekdays: Weekdays | undefined;
  setFilterTyp: (t: ("floor" | SelectedZoneOrWorkplaceType | undefined)[]) => void;
  dispatch: AppDispatch;
};
export function refetchCapaReportWithSelected({
  defaultParams,
  currentFloors,
  fetchReport,
  selectedZoneOrWorkplace,
  selectedWeekdays,
  setFilterTyp,
  dispatch
}: RefetchCapaReportWithSelected) {
  if (selectedZoneOrWorkplace?.open) {
    setFilterTyp([selectedZoneOrWorkplace.type, undefined]);
    dispatch(
      fetchReport({
        ...defaultParams,
        id: selectedZoneOrWorkplace.id,
        filterType: selectedZoneOrWorkplace.type,
        bookingType: selectedZoneOrWorkplace.bookingType,
        selectedWeekdays: selectedWeekdays
      })
    );
  } else {
    const secondFilterTyp = currentFloors.length > 1 && currentFloors[1].open;
    setFilterTyp(["floor", secondFilterTyp ? "floor" : undefined]);
  }
}
